import apiClient from "./client";
import type {
  DisasterIdParam,
  DisasterStatusGetResponse,
  DisasterStatusMutationResponse,
  UpdateDisasterStatusPayload,
} from "../types/disaster";

export const getDisasterStatus = async (
  statusId: DisasterIdParam
): Promise<DisasterStatusGetResponse> => {
  const { data } = await apiClient.get<DisasterStatusGetResponse>(
    `/disaster-status/${statusId}`
  );
  return data;
};

export const updateDisasterStatus = async (
  payload: UpdateDisasterStatusPayload
): Promise<DisasterStatusMutationResponse> => {
  const { data } = await apiClient.put<DisasterStatusMutationResponse>(
    "/disaster-status",
    payload,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return data;
};
